import { ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ILinksData } from '../dobbies-account-menu.props.autogenerated';
import { _mapLinksToDropDown, getSelectedLink, ILinkType } from './dropDown';

export interface IContentCardLinks {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;
    telemetryContent: ITelemetryContent;
    url: string;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

/**
 *
 * ContentCardLinks component
 * @extends {React.PureComponent<IContentCardLinks>}
 */
export class ContentCardLinks extends React.PureComponent<IContentCardLinks> {
    public render(): JSX.Element {
        const mappedLinks = _mapLinksToDropDown(this.props.links);
        const selectedLink = getSelectedLink(mappedLinks, this.props.url);
        return (
            <div className='ms-dobbies-account__cta'>
                <ul className='account-menu__list'>
                    {mappedLinks.map((link: ILinkType) => (
                        <li
                            key={link.linkText}
                            className={
                                link.linkText === selectedLink?.linkText ? 'account-menu__list--item active' : 'account-menu__list--item'
                            }
                        >
                            <a href={link.destinationUrl}>{link.linkText}</a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
export default ContentCardLinks;
